import { render, staticRenderFns } from "./bulkVehicleStatus.vue?vue&type=template&id=13d608f0&scoped=true"
import script from "./bulkVehicleStatus.vue?vue&type=script&lang=js"
export * from "./bulkVehicleStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d608f0",
  null
  
)

export default component.exports